const Our = () => {
  return (
    <>
      <section className=" container-fluid" id="demo2">
        <section className="container mt-4 ">
          <section className="row">
            <div className="col-12">
              <h2 className="heading fw-bold mb-4">OUR PRICING PLANS</h2>
              <p>
                Lacinia bibendum sed dictumst consectetur. <br />Non adipiscing arcu
                vitae neque. Felis enim sit gravida sem. Egestas quis pretium
                aliquet.
              </p>
            </div>

            <div className="card-group py-4">
              <div className="card me-2  py-5 px-5 me-2" id="SET">
                <div className="card-body" >
                  <h5 className="card-title">ONE-DAY VISIT $20/DAY</h5>
                  <p className="card-text">urna neque mi dignissim</p>
                  <p>Neque,urna nibh proin leo integ</p>
                  <p>Vitae rhoncus eu vitae quam</p>
                  <p>Tortor praesent nisl orci</p>
                  <button className="btn btn-outline-success" type="submit">
                    PURCHASE NOW
                  </button>
                </div>
              </div>
              <div className="card py-5 px-5 me-2" id="SET1">
                <div className="card-body" >
                  <h5 className="card-title">MONTHLY PASS $49/MO</h5>
                  <p className="card-text">urna neque mi dignissim</p>
                  <p>
                    <p>Neque,urna nibh proin leo integ</p>
                  </p>
                  <p>Vitae rhoncus eu vitae quam</p>
                  <p>Tortor praesent nisl orci</p>
                  <button className="btn btn-outline-success" type="submit">
                    PURCHASE NOW
                  </button>
                </div>
              </div>
              <div className="card py-5 px-5" id="SET2">
                <div className="card-body me-2" >
                  <h5 className="card-title">YEARLY PASS $89/YR</h5>
                  <p className="card-text">urna neque mi dignissim</p>
                  <p>
                    <p>Neque,urna nibh proin leo integ</p>
                  </p>
                  <p>Vitae rhoncus eu vitae quam</p>
                  <p>Tortor praesent nisl orci</p>
                  <button className="btn btn-outline-success" type="submit">
                    PURCHASE NOW
                  </button>
                </div>
                <div></div>
              </div>
            </div>
            <div>
              <p className="text-center">Have any questions? Contact us.</p>
            </div>
          </section>
        </section>
      </section>
    </>
  );
};

export default Our;
